import { Link } from "react-router-dom";
import * as m from "motion/react-m";
import type { StoryCard as Story } from "../api/client";
import { when } from "../lib/format";
import { RichText } from "./RichText";
import { Favicon } from "./Favicon";
import { CountryFlag } from "./CountryFlag";

export function StoryCard({
  story,
  index = 0,
  onTerm,
}: {
  story: Story;
  index?: number;
  onTerm: (id: string) => void;
}) {
  const shown = story.terms.filter((t) => !t.understood);
  return (
    <m.article
      className="card"
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut", delay: Math.min(index, 8) * 0.04 }}
      whileTap={{ scale: 0.985 }}
    >
      <Link className="stretch" to={`/stories/${story.id}`} aria-label={`Open: ${story.title}`} />
      <div className="meta">
        <span className="mono source">
          <Favicon domain={story.source} />
          <CountryFlag iso3={story.country_iso3} />
          {story.source} · {when(story.published_at)}
        </span>
        <span className="tag">{story.topic}</span>
      </div>
      <h2>
        <RichText text={story.title} spans={story.spans.title ?? []} onTerm={onTerm} />
      </h2>
      {story.snippet && (
        <p className="snip">
          <RichText text={story.snippet} spans={story.spans.snippet ?? []} onTerm={onTerm} />
        </p>
      )}
      <div className="chips">
        {shown.slice(0, 3).map((t) => (
          <button key={t.id} type="button" className="chip" onClick={() => onTerm(t.id)}>
            {t.name}
          </button>
        ))}
        {shown.length > 3 && <span className="mono">+{shown.length - 3}</span>}
        {story.terms.length > 0 && shown.length === 0 && (
          <span className="chip done">All terms understood</span>
        )}
        <span className="stat">
          <span title="Sources">
            🗞️{" "}
            {story.sources} source{story.sources === 1 ? "" : "s"}
          </span>
          <span title="Discussion replies">💬 {story.replies}</span>
        </span>
      </div>
    </m.article>
  );
}
